import * as _ from "lodash";
import { SubjectMerge } from "./SubjectMerge";
import {MailroomSchoolConfig} from "./MailroomSchoolConfig";


export type EditableDtoProperty = "mailroomSchoolConfig" | "strategy" | "subjectMerges";
export interface SchoolMailroomConfigDto
{
    mailroomSchoolConfig: MailroomSchoolConfig;
    strategy?: SalamanderStrategy;
    subjectMerges?: SubjectMerge[];
    
    strategyError: boolean;
    strategyErrorReason?: string;
}

export interface TriggerMailroomProcessorOverrides {
    strategy?: SalamanderStrategy,
    options?: MailroomOptions,
    academicYear?: string,
    excludeClassesWithSubjectCodes?: string[],
    subjectMerges?: SubjectMerge[],
    injectedTeachers?: string[];
    excludedUserPhotos?: string[];
    misDataServiceType?: MisDataServiceTypes;

    className?: string[];
    regGroupClassName?: string[];
    subjectYearClassName?: string[];
    pastoralHouseClassName?: string[];
    userDefinedGroupClassName?: string[];
    yearClassName?: string[];

    yearGroupCourseOption?: string;
    regGroupCourseOption?: string;
    classCourseOption?: string;
    guardianPhoneNumberOption?: string;
    studentGradeOption?: string;
}

export interface MailroomOptions {
    [key: string]: boolean;
    includePleaseDoNotUsePrefixOnAllClasses: boolean;
    includeStudentMemberships: boolean;
    includeTeachingClasses: boolean;
    includeRegClasses: boolean;
    includeParentGuardian: boolean;
    includeHouseClasses: boolean;
    includeTeacherPhotos: boolean;
    includeStudentPhotos: boolean;
    includeClubClasses: boolean;
    includeUDGClasses: boolean;
    includeSubjectYearClasses: boolean;
    includeYearClasses: boolean;
    useAadStudentJoin: boolean;
    useAadTeacherJoin: boolean;
}


export enum MisDataServiceTypes {
    None = "None",
    SalamanderWebService = "SalamanderWebService",
    SalamanderHosted = "SalamanderHosted",
    Arbor = "Arbor",
    DeveloperTestData = "DeveloperTestData"
}


export interface SalamanderStrategy {
    [key: string]: SalamanderStrategyGroup | any;

    name: string;
}

export interface SalamanderStrategyGroup {
    [key: string]: SalamanderSubStrategy;
}

export interface SalamanderSubStrategy {
    $type: string;
    description: string;
}

export interface SalamanderSubStrategyMetaData {
    hasObsoleteAttribute: boolean;
}

export interface SalamanderSubStrategyAndMetaData {
    option: SalamanderSubStrategy;
    metaData: SalamanderSubStrategyMetaData;
}

export const shortenSalamanderSubStrategyType = (type: string) => {
    const parentNameSpace = "Salamander.Strategies.";  //Assume all sub strategy types are nested within this namespace 

    const a = _.split(type, ",")[0];
    return _.split(a, parentNameSpace)[1];
};

export const getStrategyName = (type: string) => {
    var short = shortenSalamanderSubStrategyType(type);

    var split = _.split(short, "+");

    return split[split.length - 1];
}

export const getMisDataServiceTypeDisplayInfo = (misDataServiceType?: MisDataServiceTypes): { name: string, detail: string } => {
    switch (misDataServiceType) {
        case MisDataServiceTypes.SalamanderHosted:
            return {
                name: "CDB Cloud",
                detail: "Salamander Hosted"
            };

        case MisDataServiceTypes.SalamanderWebService:
            return {
                name: "Inbox",
                detail: "Salamander Web Service"
            };

        case MisDataServiceTypes.DeveloperTestData:
            return {
                name: "Test Data",
                detail: "DEVELOPER ONLY"
            };

        case MisDataServiceTypes.Arbor:
            return {
                name: "Arbor",
                detail: "Direct Integration"
            }

        case MisDataServiceTypes.None:
            return {
                name: "None",
                detail: ""
            };

        default:
            return {
                name: "Unknown",
                detail: ""
            };
    }
}

